import { EditOfferModal } from 'features/discount-code/components/modal/edit-offer-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

export const EditOfferEditView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.DISCOUNT_CODE_OFFER_LIST);
    document.body.style.overflow = 'visible';
  };

  return <EditOfferModal id={id} onClose={closeModal} onSuccess={closeModal} />;
};
